import { render, staticRenderFns } from "./RideInformation.vue?vue&type=template&id=2370bc94&"
import script from "./RideInformation.vue?vue&type=script&lang=js&"
export * from "./RideInformation.vue?vue&type=script&lang=js&"
import style0 from "./RideInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports